module.exports = __webpack_public_path__ + "static/media/me-optimized.1f6c9415.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/01-intro/assets/me-optimized.jpg
// module id = 925
// module chunks = 0